import React, { Component } from 'react';
import styled from 'styled-components';
import TitleWithContent from '../common/TitleWithContent';
import { BoxWrapper } from '../common/style';
import MS from "../../../commons/services/Moment";
import StatTable from '../../../commons/components/table/StatTable';
import { withTranslation } from 'react-i18next';

// ----------------------S: SystemInfo ---------------------- //

class SystemInfo extends Component {
  render() {
    const { systemInfo, t } = this.props;
    const { battery, solar, device } = systemInfo;
    const { 
      installationCapacity,
      count: solarCount,
    } = solar;
    const { 
      capacity: batteryCapacity,
      count: batteryCount,
    } = battery;
    const { capacity: deviceCapacity, count: deviceCount } = device;

    return (
      <TitleWithContent title={t('key79')}>
        <BoxWrapper height={"325px"}>
          <TitleWithTable
            title={t('key92')}
            data={[
              { label: t('key93'), value: MS.current("YY-MM-DD") },
              { label: t('key94'), value: MS.current("A hh:mm") }
            ]}
          />
          <TitleWithTable
            title={t('key95')}
            data={[
              { label: t('key96'), value: batteryCapacity, unit: "kWh" },
              { label: t('key97'), value: batteryCount, unit: t("key527") },
            ]}
          />
          <TitleWithTable
            title={t('key98')}
            data={[
              { label: t('key99'), value: installationCapacity, unit: `kW` },
              { label: t('key100'), value: solarCount, unit: t("key527") },
            ]}
          />
          <TitleWithTable
            title={t('key101')}
            data={[
              { label: t('key102'), value: deviceCapacity, unit: 'kWh' },
              { label: t('key103'), value: deviceCount, unit: t("key527") },
            ]}
          />
        </BoxWrapper>
      </TitleWithContent>
    )
  }
}

class TitleWithTable extends Component {
  render() {
    const {
      title,
      data,
    } = this.props;
    return (
      <TitleWidthTableContainer>
        <strong>
          {title}
        </strong>
        <StatTable colCount={data.length || 1} data={data} />
      </TitleWidthTableContainer>
    )
  }
}
const TitleWidthTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > strong {
    font-size: 14px;
    font-weight: bold;
    height: 16px;
    margin-bottom: 5px;
  }
  
  & ~ & {
    margin-top: 6px;
  }
`;

// ----------------------E: SystemInfo ---------------------- //
export default withTranslation()(SystemInfo);